import { Classified } from '../../rest/types/Classified'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { Configuration } from '../../rest/types/Configuration'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'
import { EmitterType } from '../../rest/types/api/Classified'
import { ListDisplayType } from '../../types/classified'

import { ImageTransformer } from './ImageTransformer'

export function ClassifiedAuthorCardTransformer({
  classified,
  t,
  configuration,
}: {
  classified: Classified
  t: any
  configuration: Configuration
}) {
  const adsCount = classified?.user_published_classifieds_count ?? 0

  return classified
    ? {
        avatar: {
          photo: classified?.emitter?.logo
            ? ImageTransformer(classified?.emitter?.logo as any)
            : ImageTransformer(
                (classified?.emitter?.user?.avatar as any) ??
                  (configuration.config.defaultAvatar as any)
              ),
          ...(!classified?.emitter?.type && {
            name:
              classified?.user?.profile?.name === t('user_profile_doctor_type')
                ? `${t('ads_author_card_doctor_prefix')} ${
                    classified?.user?.firstName
                  } ${classified?.user?.lastName}`
                : `${classified?.user?.firstName} ${classified?.user?.lastName}`,
            surname: classified?.user?.speciality?.name,
          }),
          ...(classified?.emitter?.type === EmitterType.Doctor && {
            name:
              classified?.user?.profile?.name === t('user_profile_doctor_type')
                ? `${t('ads_author_card_doctor_prefix')} ${
                    classified?.user?.firstName
                  } ${classified?.user?.lastName}`
                : `${classified?.user?.firstName} ${classified?.user?.lastName}`,
            surname: classified?.user?.speciality?.name,
          }),
          ...(classified?.emitter?.type === EmitterType.Organization && {
            surname: classified?.emitter?.name,
          }),
        },
        description: classified?.emitter?.presentation ?? '',
        ...(classified.emitter?.website && {
          button: {
            href: classified?.emitter?.website,
            label: t('discover_button_text'),
            variant: ActionButtonVariant.tertiary,
          },
        }),
        addressLabel: t('ads_author_card_address_label'),
        address: classified?.address ?? '',
        links: {
          // The count includes the viewed classified: no link when it is the only one
          ...(adsCount > 1 && {
            discoverAds: {
              href: Router.getRouteUrl(routes.classifiedsEmitter, {
                // Legacy classifieds have no emitter: the list page also accepts a user documentId
                id: classified?.emitter?.id ?? classified?.user?.documentId,
                displayType: ListDisplayType.Card,
              }),
              label: t('ads_author_card_discover_link_text'),
            },
          }),
        },
        adsNumber: `(${adsCount})`,
      }
    : undefined
}
